<template>
  <div class="address-message">
    <van-row gutter="10">
      <van-col>
        <img class="address-Icon" src="@/assets/images/addressIcon.png" />
      </van-col>
      <van-col span="20">
        <div>
          <span>{{detailObjects.contacts}}</span>
          <span class="address-phone">{{detailObjects.phoneNumber}}</span>
        </div>
        <div class="address-details">{{detailObjects.address}}{{detailObjects.detailsAddress}}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    detailObjects: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0px;
  padding: 0px;
}
.address-message {
  font-size: 12px;
  background-color: #fff;
  padding: 12.5px 0 0 25px;
  margin: 10px 0px 0px;
  color: #666;
  .address-Icon {
    width: 20px;
    height: 25px;
    padding-top: 2.5px;
  }
  .address-phone {
    padding-left: 7.5px;
  }

  .address-details {
    padding: 10px 0px 10px;
    color: #adadad;
  }
}
.van-row {
  margin: 0px !important;
}
</style>
